module.exports = __webpack_public_path__ + "static/media/marketo-logo-text.6ebd6566.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/marketo-logo-text.png
// module id = /8Kr
// module chunks = 89